import { observer } from 'mobx-react-lite';
import React, { Suspense } from 'react';
import { renderRoutes, RouteConfig } from 'react-router-config';
import { Loading } from '@/presentation/components/loading';
import { flatten } from '@/presentation/routes/flatten';
import { getRoutes } from '@/presentation/routes/routes';
import { useStores } from '@/presentation/store';
import style from './index.module.scss';

export const Content = observer(() => {
  const { loaded, productId } = useStores().ProductStore;
  const routes: RouteConfig[] = getRoutes();

  const loading = (
    <div style={{ flex: '1' }}>
      <Loading />
    </div>
  );

  if (!loaded) {
    return loading;
  }

  const flattenRoutes = flatten(routes);
  return (
    <div className={style.pageContent} key={productId}>
      <Suspense fallback={loading}>{renderRoutes(flattenRoutes)}</Suspense>
    </div>
  );
});
